import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { IsDevice } from '../../../../decorators/is-device.decorator';
import { ModalClose } from '../../../../decorators/modal-close.decorator';
import { CountryWithChild } from '../../../../domains/country-with-child';
import { CountyWithChild } from '../../../../domains/county-with-child';
import { StateWithChild } from '../../../../domains/state-with-child';
import { DeviceType } from '../../../../models/enums/device-type';
import { SearchFiltersPosition } from '../../../../models/enums/search-filters-position';
import { Place } from '../../../../models/place';
import { SearchFiltersPositionWrapper } from '../../../../models/wrappers/search-filters-position.wrapper';
import { SearchCityService } from '../../../../services/search-city.service';
import { HashUtils } from '../../../../utils/hash-utils';

@Component({
  selector: 'app-search-location-modal',
  templateUrl: './search-location-modal.component.html',
  styleUrls: ['./search-location-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchLocationModalComponent implements OnInit, OnDestroy {
  @Input() stateSelected: StateWithChild;

  @Output() selectPlace = new EventEmitter<Place>();
  @Output() findMe = new EventEmitter<boolean>();
  @Output() selectRestaurant = new EventEmitter<boolean>();
  @Output() localitySelectedChange = new EventEmitter<boolean>();
  @Output() countyChange = new EventEmitter<CountyWithChild>();

  @ViewChild('cityInput', { static: false }) searchCityInput!: ElementRef;

  @IsDevice(DeviceType.MOBILE) isMobile: boolean;

  country: CountryWithChild;
  searchValueExists = false;
  hash: string;
  searchFiltersPositionMobile = new SearchFiltersPositionWrapper(SearchFiltersPosition.MOBILE);
  countrySubscription: Subscription;
  clearIcon = false;
  isLocalitySelected: boolean;
  countySelected: CountyWithChild;
  locationEnable = false;
  deviceInfo: any;
  htmlInstruction = '';

  constructor(
    private searchCityService: SearchCityService,
    private deviceDetectorService: DeviceDetectorService,
    ) {
  }

  ngOnInit(): void {
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();

    this.hash = HashUtils.getCodePositionUniqueHash();

    this.countrySubscription = this.searchCityService.countrySubject.subscribe(country => {
      this.country = country;
    });

    if (this.deviceInfo?.os === 'iOS') {
      this.htmlInstruction = 'Settings > Privacy & Security > Location Services';
    } else if (this.deviceInfo?.os === 'Android') {
      this.htmlInstruction = 'Settings > Location > Location Access';
    }
  }

  ngOnDestroy() {
    this.countrySubscription.unsubscribe();
  }

  searchInputValue(searchValue: string) {
    this.searchValueExists = !!searchValue;
  }

  focusValue(event) {
    this.clearIcon = event;
  }

  onSelectPlace(place: Place) {
    this.selectPlace.emit(place);

    this.goBack();
  }

  onFindMe() {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.findMe.emit(true);

        this.goBack();
      },
      (error) => {
        this.locationEnable = true;
      }
    );
  }

  nearestClick() {
    navigator.geolocation.getCurrentPosition(
      (position) => {

      },
      (error) => {
        this.locationEnable = true;
      }
    );
  }

  @ModalClose()
  goBack() {
  }

  onSelectRestaurant($event: boolean) {
    this.selectRestaurant.emit($event);

    this.goBack();
  }

  onStateChange(event) {
    setTimeout(() => {
      this.stateSelected = event;
    });
  }

  onLocalitySelectedChange(isLocalitySelected: boolean) {
    setTimeout(() => {
      this.isLocalitySelected = isLocalitySelected;
    });
  }

  onCountyChange(event) {
    this.countySelected = event;
  }
}
